<form [formGroup]="form" (submit)="onSubmit()">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Dashboard</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <mat-dialog-content primaryActionBtnText="Create" titleText="Add Dashboard">
    <div dialog-content>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input type="text" matInput required formControlName="name" />
        @if (form.get('name')?.hasError('required')) {
          <mat-error>Name is required</mat-error>
        }
        @if (form.get('name')?.hasError('whitespace')) {
          <mat-error
            >No leading/trailing whitespace is allowed</mat-error
            >
          }
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button type="submit" title="Create" mat-raised-button>Create</button>
    </mat-dialog-actions>
  </form>
